export default [

     {
          path: '/program',
          name: 'Program',
          component: () => import("@/views/Page/StrategicPlan/Program/Program.vue"),
           meta: {
               title: 'Program',
          },
     }
];